export default {
  columns: {
    version: 'Versiune',
    signed_at: 'Semnat la',
    internal_note: 'Notă internă',
    signature_provider: 'Furnizor semnătură',
    file: 'Document',
    actions: 'Acțiuni',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Nu există încă istoric de semnături',
    providers: {
      selfhosted: 'Auto-găzduit',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Previzualizare',
    download: 'Descărcați',
  },
};
